"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParsedArtifactId = exports.NestedArtifact = exports.Error = exports.Artifact = void 0;
exports.extractOrgName = extractOrgName;
exports.getPrimaryWebLink = void 0;
exports.isAdoReleaseDefinitionEnv = isAdoReleaseDefinitionEnv;
exports.isAreaPath = isAreaPath;
exports.isDisabled = isDisabled;
exports.isPipeline = isPipeline;
exports.isRepository = isRepository;
exports.splitArtifactId = splitArtifactId;
var _config = require("../../../config");
var _ArtifactActions = require("./ArtifactActions");
var _ProductArtifactTypes = require("./ProductArtifactTypes");
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var Artifact = /*#__PURE__*/_createClass(function Artifact() {
  _classCallCheck(this, Artifact);
});
exports.Artifact = Artifact;
var NestedArtifact = /*#__PURE__*/function (_Artifact) {
  _inherits(NestedArtifact, _Artifact);
  var _super = _createSuper(NestedArtifact);
  function NestedArtifact() {
    var _this;
    _classCallCheck(this, NestedArtifact);
    _this = _super.call(this);
    _this.childArtifacts = [];
    return _this;
  }
  return _createClass(NestedArtifact);
}(Artifact);
exports.NestedArtifact = NestedArtifact;
var Error = /*#__PURE__*/_createClass(function Error() {
  _classCallCheck(this, Error);
});
exports.Error = Error;
var ParsedArtifactId = /*#__PURE__*/_createClass(function ParsedArtifactId() {
  _classCallCheck(this, ParsedArtifactId);
  _defineProperty(this, "organizationId", "");
  _defineProperty(this, "projectId", "");
  _defineProperty(this, "adoArtifactId", "");
});
exports.ParsedArtifactId = ParsedArtifactId;
function extractOrgName(artifactLinks) {
  var currentLink = artifactLinks ? artifactLinks[0] : null;
  if (currentLink) {
    var parsedLink = new RegExp(/https:\/\/dev.azure.com\/(.*?)\/.*/).exec(currentLink.web);
    if (parsedLink) {
      return parsedLink[1];
    }
  }
  return "";
}
function splitArtifactId(artifactId) {
  var parsedId = new RegExp(/(?:.*:)\/\/(.*)\/(.*)\/(.*)/).exec(artifactId);
  if (parsedId && parsedId.length > 3) {
    return {
      organizationId: parsedId[1],
      projectId: parsedId[2],
      adoArtifactId: parsedId[3]
    };
  }
  return new ParsedArtifactId();
}
function isDisabled(orgName, artifactType, artifactDisabledItems) {
  var _Config$getValue;
  var currentOrgName = orgName ? orgName.toLowerCase() : "";
  var rawDisabledOrgs = (_Config$getValue = _config.Config.getValue("UI:EDIT_BLOCKED_ORGS_AND_ARTIFACTS")) !== null && _Config$getValue !== void 0 ? _Config$getValue : [];
  var sanitizedDisabledOrgs = sanitizeOrgNames(rawDisabledOrgs);
  if (currentOrgName in sanitizedDisabledOrgs) {
    var blockedArtifacts = sanitizedDisabledOrgs[currentOrgName].blockedArtifacts;
    var blockedActions = sanitizedDisabledOrgs[currentOrgName].blockedActions;

    // Check if blockedActions are undefined/null. If artifactDisableItems class isn't given, fall back to blocked artifact list
    if (!blockedActions || blockedActions.length === 0 || !artifactDisabledItems) {
      var result = blockedArtifacts.includes(artifactType);
      if (artifactDisabledItems) {
        artifactDisabledItems.disabledByOrg = result;
      }
      return result;
    }

    // Evaluate correct classification of artifact type for proper action handling.
    if (isRepository(artifactType)) {
      artifactDisabledItems.disableAddArtifactMapping = blockedActions.includes(_ArtifactActions.ArtifactActions.ADD_ARTIFACT_MAPPING_REPO);
      artifactDisabledItems.disableDeleteArtifactsMapping = blockedActions.includes(_ArtifactActions.ArtifactActions.DELETE_ARTIFACT_MAPPING_REPO);
      artifactDisabledItems.disableSaveArtifactTag = blockedActions.includes(_ArtifactActions.ArtifactActions.SAVE_ARTIFACT_TAG_REPO);
    } else if (isPipeline(artifactType)) {
      artifactDisabledItems.disableAddArtifactMapping = blockedActions.includes(_ArtifactActions.ArtifactActions.ADD_ARTIFACT_MAPPING_PIPELINE);
      artifactDisabledItems.disableDeleteArtifactsMapping = blockedActions.includes(_ArtifactActions.ArtifactActions.DELETE_ARTIFACT_MAPPING_PIPELINE);
      artifactDisabledItems.disableSaveArtifactTag = blockedActions.includes(_ArtifactActions.ArtifactActions.SAVE_ARTIFACT_TAG_PIPELINE);
    } else if (isAreaPath(artifactType)) {
      // currently no actions effect areaPaths
      artifactDisabledItems.disableAddArtifactMapping = false;
      artifactDisabledItems.disableDeleteArtifactsMapping = false;
      artifactDisabledItems.disableSaveArtifactTag = false;
    }
    if (artifactDisabledItems.isDisabledByOrg(blockedArtifacts.includes(artifactType))) {
      return artifactDisabledItems.isDisabledByOrg();
    }
  }
  if (artifactDisabledItems) {
    if (isAdoReleaseDefinitionEnv(artifactType)) {
      artifactDisabledItems.disableDeleteArtifactsMapping = true;
    }
    if (artifactDisabledItems.isACustomToolTipNeeded()) {
      constructPartialDisabledMessage(artifactType, artifactDisabledItems);
    }
  }
  return false;
}
function sanitizeOrgNames(blockedOrgSettings) {
  var sanitizedOrgs = {};
  Object.entries(blockedOrgSettings).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    sanitizedOrgs[key.toLowerCase()] = value;
  });
  return sanitizedOrgs;
}
function isRepository(artifactType) {
  switch (artifactType) {
    case _ProductArtifactTypes.ProductArtifactsTypes.GitHubRepo:
    case _ProductArtifactTypes.ProductArtifactsTypes.Git:
      return true;
    default:
      return false;
  }
}
function isPipeline(artifactType) {
  switch (artifactType) {
    case _ProductArtifactTypes.ProductArtifactsTypes.AdoBuildDefs:
    case _ProductArtifactTypes.ProductArtifactsTypes.AdoReleaseDefEnv:
    case _ProductArtifactTypes.ProductArtifactsTypes.AdoReleaseDefs:
      return true;
  }
  return false;
}
function isAdoReleaseDefinitionEnv(artifactType) {
  return artifactType === _ProductArtifactTypes.ProductArtifactsTypes.AdoReleaseDefEnv;
}
function isAreaPath(artifactType) {
  return artifactType === _ProductArtifactTypes.ProductArtifactsTypes.AreaPathVSTS;
}
function constructPartialDisabledMessage(artifactType, artifactDisabledItems) {
  var stringArray = [];
  if (!artifactDisabledItems.disableDeleteArtifactsMapping) {
    stringArray.push("Unassign");
  }
  if (!artifactDisabledItems.disableSaveArtifactTag) {
    stringArray.push(stringArray.length > 0 ? "or classify" : "Classify");
  }
  if (isRepository(artifactType)) {
    stringArray.push("the repository");
  } else if (isPipeline(artifactType)) {
    stringArray.push("the pipeline");
  }
  artifactDisabledItems.partialDisabledToolTip = stringArray.join(" ");
}
var getPrimaryWebLink = function getPrimaryWebLink(artifact) {
  var _artifact$links;
  return artifact === null || artifact === void 0 ? void 0 : (_artifact$links = artifact.links) === null || _artifact$links === void 0 ? void 0 : _artifact$links[0].web;
};
exports.getPrimaryWebLink = getPrimaryWebLink;